module.exports = __webpack_public_path__ + "static/media/phone-04.50378a1e.png";